import { GridItem } from '@bnnvara/grids';
import React from 'react';

import NewsletterSubscription from '../components/NewsletterSubscription';

const ComposableNewsletterSubscription = () => (
  <GridItem
    columnStartSm="1"
    columnEndSm="span 12"
    columnStartMd="2"
    columnEndMd="span 10"
    columnStartLg="3"
    columnEndLg="11"
  >
    <NewsletterSubscription />
  </GridItem>
);

export default ComposableNewsletterSubscription;
